module.exports = __webpack_public_path__ + "img/donate-bg.56db14ac.jpg";